module.exports = __webpack_public_path__ + "static/media/3.7a02f39e.jpg";